import { render } from "./ResourceCard.vue?vue&type=template&id=57f96ed8&scoped=true"
import script from "./ResourceCard.vue?vue&type=script&lang=js"
export * from "./ResourceCard.vue?vue&type=script&lang=js"

import "./ResourceCard.vue?vue&type=style&index=0&id=57f96ed8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f96ed8"]])

export default __exports__